<!-- 解决方案 -->
<template>
  <div class="dtwin-solution-container">
    <div class="dtwin-solution-wrapper">
      <header
        class="dtwin-solution-hd"
        v-scroll-animate="{
          animation: 'fadeInUp',
        }"
      >
        {{ title }}
      </header>
      <article
        class="dtwin-solution-bd text-wrap"
        v-scroll-animate="{
          animation: 'fadeInUp',
          delay: 200,
        }"
      >
        {{ desc }}
      </article>
    </div>
  </div>
</template>

<script>
export default {
  name: "Solution",
  components: {},
  data() {
    return {
      title:
        "基础设施运维数字孪生解决方案",
      desc: "\u3000\u3000数字孪生底座是一种技术框架，用于创建数字孪生模型并将其与实际物理系统或过程进行连接。它结合了物理世界和数字世界，通过实时数据采集、模型仿真和分析，为实际系统提供智能化的监测、优化和预测能力。\n\u3000\u3000数字孪生底座的应用领域广泛，狄诺尼已将其运用在道路交通，水利航道，城市规划业务中。通过数字孪生底座，可以实现对实际系统的全面监测和控制，提高系统的运行效率、降低维护成本，并为系统的未来发展提供决策支持。",
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/common.scss";
.dtwin-solution-container {
  padding: 64px 0;
  background: #fff;
  .dtwin-solution-wrapper {
    width: 1200px;
    margin: 0 auto;
  }

  .dtwin-solution-hd {
    margin-bottom: 24px;
    font-weight: bold;
    font-size: 32px;
    color: #333;
    line-height: 24px;
    text-align: center;
    font-style: normal;
  }
  .dtwin-solution-bd {
    font-weight: 400;
    font-size: 18px;
    color: #333;
    line-height: 40px;
    text-align: justify;
    font-style: normal;
  }
}
</style>
